<template>

	<div class="inbox">

		<page-bar />

		<h3 class="page-title">
			Caixa de Entrada
		</h3>

		<div class="row">

			<div class="col-md-2">
				<sidebar-menu />
			</div>

			<div class="col-md-10">
				<message-send />
			</div>

		</div>

	</div>

</template>

<script>

	import SendMessage from './';
	export default SendMessage;

</script>



// WEBPACK FOOTER //
// send-message.vue?75c2850f